import { LifeBuoy } from "lucide-react";
import { useT } from "@/lib/i18n";
import { getSupportUrl } from "@/lib/support";

/** Floating shortcut to support: a round button on phones, a labelled pill on larger screens. */
export function SupportFab() {
  const t = useT();
  const label = t("common.support_contact");
  return <a className="support-fab" href={getSupportUrl()} target="_blank" rel="noopener noreferrer" aria-label={label}><LifeBuoy size={20} aria-hidden="true" /><span>{label}</span></a>;
}
